<div class="container pt-5">
  <h1 class="text-title mb-3" i18n>We offer two business model options</h1>
  <h6 class="text-subtitle mb-3" i18n>
    By submitting their Application and Agreement, all new Consultants begin their business under
    the model known as Wholesale Discount Consultant. If you'd like to upgrade to the Earned
    Consultant model later, you can do so by completing additional identity verification steps.
  </h6>

  <div class="row" *ngIf="wholeSaleReatailKits">
    <div class="col-md-6" *ngFor="let wholeSaleReatailKit of wholeSaleReatailKits">
      <app-wholesale-retail-card
        [wholesaleRetailKit]="wholeSaleReatailKit"
        [isSelected]="isSelected(selectedtWholeSaleRetailKit, wholeSaleReatailKit)"
        (selectChange)="selectWholesaleRetailKit($event)"
      ></app-wholesale-retail-card>
    </div>
  </div>
   <div class="row mt-4">
    <div class="col-12 col-md-8">
      <span i18n>Click “Continue” to proceed to the next step.</span>
    </div>
  </div>
  <div class="row justify-content-center my-5 pt-5">
    <div class="col col-md-3">
      <div class="white-button-container">
        <button
          class="btn btn-outline-primary text-uppercase w-100 no-button"
          i18n
          (click)="previousStepClick()"
          [disabled]="isGoToPreviousDisabled"
        >
          Back
        </button>
      </div>
    </div>
    <div class="col col-md-3">
      <button class="btn btn-primary text-uppercase w-100" i18n (click)="nextStepClick()">
        Next
      </button>
    </div>
  </div>
</div>
